/* --------------------------------------------------------------------------
 * Набор иконок для публичной главной страницы.
 *
 * Эмодзи в вёрстке рисуются шрифтом системы: на Windows, Android и iOS это
 * три разных картинки, разного веса и цвета — на тёмном фоне разнобой особенно
 * заметен. Здесь простые штриховые SVG на currentColor: одинаковые везде,
 * наследуют цвет и толщину линии от блока, в котором стоят.
 * -------------------------------------------------------------------------- */

export type MotoIconName =
  | 'helmet'
  | 'road'
  | 'clipboard'
  | 'rotate'
  | 'moto'
  | 'calendar'
  | 'bolt'
  | 'wallet'
  | 'arrow';

/** Общая геометрия: сетка 24×24, штрих 1.5, скруглённые концы. */
const PATHS: Record<MotoIconName, React.JSX.Element> = {
  helmet: (
    <>
      <path d="M3.5 13.5a8.5 8.5 0 1 1 17 0V16a2 2 0 0 1-2 2h-6.2l-6.6-1.1a2 2 0 0 1-1.7-2z" />
      <path d="M8.6 12.2h11.6" />
    </>
  ),
  road: (
    <>
      <path d="M8.5 21 4 3M15.5 21 20 3" />
      <path d="M12 19.5v-3M12 13.5v-3M12 7.5v-3" />
    </>
  ),
  clipboard: (
    <>
      <path d="M9 3.5h6a1 1 0 0 1 1 1v1.2H8V4.5a1 1 0 0 1 1-1z" />
      <path d="M16 5.7h2a1.5 1.5 0 0 1 1.5 1.5v12.3a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5V7.2A1.5 1.5 0 0 1 6 5.7h2" />
      <path d="m8.8 13.4 2.2 2.2 4.2-4.4" />
    </>
  ),
  rotate: (
    <>
      <path d="M20 12a8 8 0 0 1-13.6 5.7M4 12a8 8 0 0 1 13.6-5.7" />
      <path d="M20 4.5V9h-4.5M4 19.5V15h4.5" />
    </>
  ),
  moto: (
    <>
      <circle cx="5.5" cy="16.5" r="3.5" />
      <circle cx="18.5" cy="16.5" r="3.5" />
      <path d="m5.5 16.5 4.2-5.8h5.1l2.6 5.8" />
      <path d="M9.7 10.7H7.2M13.6 7.5h3l2.2 3.2" />
    </>
  ),
  calendar: (
    <>
      <path d="M4.5 6.8A1.5 1.5 0 0 1 6 5.3h12a1.5 1.5 0 0 1 1.5 1.5v12.4A1.5 1.5 0 0 1 18 20.7H6a1.5 1.5 0 0 1-1.5-1.5z" />
      <path d="M4.5 9.8h15M8.5 3.3v3.5M15.5 3.3v3.5" />
      <path d="M8.6 13.8h.01M12 13.8h.01M15.4 13.8h.01M8.6 17h.01M12 17h.01" />
    </>
  ),
  bolt: <path d="M13.3 2.5 4.6 14h6.6l-.5 7.5L19.4 10h-6.6z" />,
  wallet: (
    <>
      <path d="M3.5 7.6A1.6 1.6 0 0 1 5.1 6h11.4a1.6 1.6 0 0 1 1.6 1.6" />
      <path d="M3.5 7.6v9.8A2.6 2.6 0 0 0 6.1 20h12.3a2.1 2.1 0 0 0 2.1-2.1v-7a2.1 2.1 0 0 0-2.1-2.1H5.1" />
      <path d="M16.8 14.2h.01" />
    </>
  ),
  arrow: <path d="M4.5 12h14M13 6l6 6-6 6" />,
};

export function MotoIcon({
  name,
  className,
}: {
  name: MotoIconName;
  className?: string;
}): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className ?? 'size-6'}
      aria-hidden
    >
      {PATHS[name]}
    </svg>
  );
}
